export default "__VITE_ASSET__BGCMn5T4__"